// Generated by CoffeeScript 1.6.3
(function() {
  rjm.model.Slicer = rjm.model.LSColumn.extend({
    initialize: function(options) {
      if (!options || !options.hasOwnProperty("sid") || !options.hasOwnProperty("groupable")) {
        throw "InvalidConstructorArgs - Slicer";
      }
      _.bindAll(this, "toJSON");
      if (rjm.app.localStructure[options.sid]) {
        this.set({
          sid: parseInt(options.sid),
          name: rjm.app.localStructure[options.sid].name,
          datatype: rjm.app.localStructure[options.sid].datatype,
          derivativeType: rjm.app.localStructure[options.sid].derivative
        });
      }
      this.set({
        groupable: options.groupable
      });
    },
    toJSON: function() {
      var r, x;
      r = Backbone.RelationalModel.prototype.toJSON.call(this);
      x = {};
      x.sid = r.sid;
      x.groupable = r.groupable;
      return x;
    }
  });

  rjm.model.SlicerList = Backbone.Collection.extend({
    model: rjm.model.Slicer,
    initialize: function(models, options) {
      _.bindAll(this, "url", "comparator", "containsSid");
      if (options != null) {
        this.trendId = options.trendId;
        this.clientId = options.clientId;
      }
      return this;
    },
    url: function() {
      return $.url("/client/" + this.clientId + "/trend/" + this.trendId + "/slicers");
    },
    comparator: function(slicer) {
      var _ref;
      return (_ref = slicer.get("name")) != null ? _ref.toLowerCase() : void 0;
    },
    containsSid: function(sid) {
      var sids;
      sids = this.map(function(slicer) {
        return slicer.get("sid");
      });
      return _(sids).contains(sid);
    }
  });

  rjm.model.GASlicer = Backbone.RelationalModel.extend({
    initialize: function(options) {
      if (!options || !options.hasOwnProperty("sid") || !options.hasOwnProperty("groupable") || !options.hasOwnProperty("name")) {
        throw "InvalidConstructorArgs - GASlicer";
      }
      _.bindAll(this, "toJSON");
    },
    toJSON: function() {
      var r, x;
      r = Backbone.RelationalModel.prototype.toJSON.call(this);
      x = {};
      x.sid = r.sid;
      x.groupable = r.groupable;
      return x;
    }
  });

  rjm.model.GASlicerList = Backbone.Collection.extend({
    model: rjm.model.GASlicer,
    initialize: function(models, options) {
      _.bindAll(this, "url", "comparator", "containsSid");
      this.trendId = options.trendId;
      this.clientId = options.clientId;
      return this;
    },
    url: function() {
      return $.url("/client/" + this.clientId + "/trend/" + this.trendId + "/gaslicers");
    },
    comparator: function(slicer) {
      return slicer.get("name").toLowerCase();
    },
    containsSid: function(sid) {
      var sids;
      sids = this.map(function(slicer) {
        return slicer.get("sid");
      });
      return _(sids).contains(sid);
    },
    getBySid: function(sid) {
      return this.find(function(slicer) {
        return slicer.get('sid') === sid;
      });
    }
  });

}).call(this);
